import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DistributorsComponent } from './distributors/distributors.component';
import { ManufacturersComponent } from './manufacturers/manufacturers.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { ProductsDepartmentsComponent } from './products-departments/products-departments.component';
import { AuthGuardService } from '../auth/auth-guard.service';
import { DistributorComponent } from './distributor/distributor.component';
import { ManufacturerComponent } from './manufacturer/manufacturer.component';
import { NotAuthGuardService } from '../auth/not-auth-guard.service';
import { SuperAdminGuardService } from './super-admin-guard.service';
import { DashboardComponent } from '../dashboard/dashboard/dashboard.component';
import { LogosCompanyComponent } from "./logos-company/logos-company.component";

const superAdminRoutes: Routes = [
  { path: '', children: [
    { path: '', component: DashboardComponent, canActivate: [AuthGuardService] },
    { path: 'distributors', component: DistributorsComponent, canActivate: [AuthGuardService, SuperAdminGuardService]},
    { path: 'manufacturers', component: ManufacturersComponent, canActivate: [AuthGuardService, SuperAdminGuardService]},
    { path: 'promotions', component: PromotionsComponent, canActivate: [AuthGuardService, SuperAdminGuardService]},
    { path: 'logos', component: LogosCompanyComponent, canActivate: [AuthGuardService, SuperAdminGuardService]},
    { path: 'products-departments', component: ProductsDepartmentsComponent, canActivate: [AuthGuardService, SuperAdminGuardService]},
    { path: 'distributors/distributor/:id/:name', component: DistributorComponent, canActivate: [AuthGuardService, SuperAdminGuardService]},
    { path: 'manufacturers/manufacturer/:id/:name', component: ManufacturerComponent, canActivate: [AuthGuardService, SuperAdminGuardService]},
  ] }
];

@NgModule({
  imports: [RouterModule.forChild(superAdminRoutes)],
  exports: [RouterModule]
})
export class SuperAdminRoutingModule { }
